module.exports = __webpack_public_path__ + "img/17.0528056d.webp";